import Clarity from '@microsoft/clarity';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './instrument';

import '@fontsource/ubuntu';
import './styles.scss';

import Joi from 'joi';
import maintenancePageContent from '../maintenance/index.html';
import App from './app/app';
import { environment } from './environments/environment';

const envSchema = Joi.object({
  apiUrl: Joi.string().allow('').required(),
  supportEmail: Joi.string()
    .email({ tlds: { allow: false } })
    .required(),
  temporaryUserPermissionMaxDaysDuration: Joi.number().required().greater(1),
  internalUserEmailDomains: Joi.string().required(),
  partnerUserEmailDomains: Joi.string().required(),
  termsOfUseUrl: Joi.string().uri().required(),
  privacyPolicyUrl: Joi.string().uri().required(),
  legalUrl: Joi.string().uri().required(),
  supportUrl: Joi.string().uri().required(),
  appVersion: Joi.string().required(),
  managementHubLicenseStartDate: Joi.date().required(),
}).unknown();

const { error } = envSchema.validate(environment, {
  abortEarly: false,
});

const root = createRoot(document.getElementById('root') as HTMLElement);

if (error) {
  root.render(
    <div dangerouslySetInnerHTML={{ __html: maintenancePageContent }} />
  );
} else {
  const clarityProjectId = environment.clarityProjectId;

  if (clarityProjectId) {
    Clarity.init(clarityProjectId);
  }

  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
